module.exports = __webpack_public_path__ + "img/1280.a9deacbc.svg";